import { render, staticRenderFns } from "./PensionUnitSelectionNewButton.vue?vue&type=template&id=08255a72&scoped=true&"
import script from "./PensionUnitSelectionNewButton.vue?vue&type=script&lang=ts&"
export * from "./PensionUnitSelectionNewButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08255a72",
  null
  
)

export default component.exports